import { createFileRoute, redirect } from "@tanstack/react-router";

import AppBaseLayout from "~/components/layout/AppBaseLayout.tsx";
import { LOGIN_PATH } from "~/routes/-route-constants/appRoutes.ts";

export const Route = createFileRoute("/_auth")({
    beforeLoad: ({ context, location }) => {
        if (!context.auth.user) {
            throw redirect({
                to: LOGIN_PATH,
                search: {
                    redirect: location.href,
                },
            });
        }
    },
    component: AppBaseLayout,
});
